
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { anonRecord_type, int32_type, list_type, string_type, record_type, class_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export function UtilizationLevel__ToI18nString(this$) {
    switch (this$) {
        case "medium":
            return "utilization.level_medium";
        case "high":
            return "utilization.level_high";
        default:
            return "utilization.level_low";
    }
}

export class UtilizationPeriod extends Record {
    constructor(StartDate, EndDate) {
        super();
        this.StartDate = StartDate;
        this.EndDate = EndDate;
    }
}

export function UtilizationPeriod_$reflection() {
    return record_type("Shared.Utilization.UtilizationPeriod", [], UtilizationPeriod, () => [["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")]]);
}

export class ToolUtilizationDto extends Record {
    constructor(ToolId, DisplayName, InventoryNumber, StorageName, Level, UsedPeriods, UsedDays, TotalDays, UtilizationPercent) {
        super();
        this.ToolId = ToolId;
        this.DisplayName = DisplayName;
        this.InventoryNumber = InventoryNumber;
        this.StorageName = StorageName;
        this.Level = Level;
        this.UsedPeriods = UsedPeriods;
        this.UsedDays = (UsedDays | 0);
        this.TotalDays = (TotalDays | 0);
        this.UtilizationPercent = (UtilizationPercent | 0);
    }
}

export function ToolUtilizationDto_$reflection() {
    return record_type("Shared.Utilization.ToolUtilizationDto", [], ToolUtilizationDto, () => [["ToolId", string_type], ["DisplayName", string_type], ["InventoryNumber", string_type], ["StorageName", string_type], ["Level", string_type], ["UsedPeriods", list_type(UtilizationPeriod_$reflection())], ["UsedDays", int32_type], ["TotalDays", int32_type], ["UtilizationPercent", int32_type]]);
}

export class CategoryUtilizationDto extends Record {
    constructor(Categories, StartDate, EndDate, Tools, LowCount, MediumCount, HighCount, AverageUtilizationPercent) {
        super();
        this.Categories = Categories;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Tools = Tools;
        this.LowCount = (LowCount | 0);
        this.MediumCount = (MediumCount | 0);
        this.HighCount = (HighCount | 0);
        this.AverageUtilizationPercent = (AverageUtilizationPercent | 0);
    }
}

export function CategoryUtilizationDto_$reflection() {
    return record_type("Shared.Utilization.CategoryUtilizationDto", [], CategoryUtilizationDto, () => [["Categories", list_type(anonRecord_type(["CategoryId", string_type], ["CategoryName", string_type]))], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["Tools", list_type(ToolUtilizationDto_$reflection())], ["LowCount", int32_type], ["MediumCount", int32_type], ["HighCount", int32_type], ["AverageUtilizationPercent", int32_type]]);
}

